module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-R-34.95b5dade.png";